import React from 'react';
import { useState, useEffect } from 'react';

import t from '../Translation/Translation';

import Button from 'react-bootstrap/Button';
import { Form, FloatingLabel, Row, Col } from 'react-bootstrap';

import { logD } from '../Util/Util';
import conf from '../../config.json';

export default function Update(props) {
    logD('Drafts.Update', props);
    const selected = props.selected;

    const [invoiceState, setInvoiceState] = useState(selected.idInvoiceState);
    const invoiceStates = [
        {value: 1, text: t('pending')},
        {value: 2, text: t('paid')},
        {value: 3, text: t('past_due')},
    ];

    const [state, setState] = useState(selected.idState);
    const states = [
        {value: 1, text: t('launched')},
        {value: 2, text: t('submited')},
        {value: 3, text: t('invoiced')},
        {value: 4, text: t('paid')},
    ];

    const changeValue = (e) => {
        console.log(e.target.checked);
        e.target.value = e.target.checked;
        selected[e.target.name] = e.target.checked;
        console.log(e.target.value);
    }

    const handleSubmit = async e => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());
        data['idBrandlift'] = selected.idBrandlift;
        data['idState'] = state;
        data['idInvoiceState'] = invoiceState;
        data['idProject'] = props.project;

        console.log(data);
        fetch(conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/updateBl', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Bearer ' + props.token
            },
            body: JSON.stringify(data),
        })
        .then(props.handleError)
        .then(data => {
            props.handleFinish();
        });
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Col>
                    <FloatingLabel className="mb-3" controlId="code" label={t('id')}>
                        <Form.Control name="code" placeholder={t('id')} required defaultValue={selected.code}/>
                    </FloatingLabel>
                    <FloatingLabel className="mb-3" controlId="idExp" label={t('idExp')}>
                        <Form.Control name="idExp" placeholder={t('idExp')} type="number" min="0" required defaultValue={selected.idExp} />
                    </FloatingLabel>
                    <FloatingLabel className="mb-3" controlId="idNe" label={t('idNe')}>
                        <Form.Control name="idNe" placeholder={t('idNe')} type="number" min="0" required defaultValue={selected.idNe} />
                    </FloatingLabel>
                    <FloatingLabel className="mb-3" controlId="budget" label={t('budget')}>
                        <Form.Control name="budget" placeholder={t('budget')} defaultValue={selected.budget} />
                    </FloatingLabel>
                    <FloatingLabel className="mb-3" controlId="invoice" label={t('invoice')}>
                        <Form.Control name="invoice" placeholder={t('invoice')} defaultValue={selected.invoice} />
                    </FloatingLabel>
                    <FloatingLabel className="mb-3" controlId="name" label={t('name')}>
                        <Form.Control name="name" placeholder={t('name')} required defaultValue={selected.name} />
                    </FloatingLabel>
                </Col>
                <Col>
                    <FloatingLabel className="mb-3" controlId="amount" label={t('amount')}>
                        <Form.Control name="amount" placeholder={t('amount')} type="number" min="0" step="any" required defaultValue={selected.amount} />
                    </FloatingLabel>
                    <FloatingLabel className="mb-3" controlId="vat" label={t('vat')}>
                        <Form.Control name="vat" placeholder={t('vat')} type="number" min="0" required defaultValue={selected.vat} />
                    </FloatingLabel>
                    <FloatingLabel className="mb-3" controlId="invoiceStates" label={t('invoice_state')}>
                        <Form.Select name="invoiceStates"
                            value={invoiceState}
                            onChange={e => {
                            console.log("e.target.value", e.target.value);
                            setInvoiceState(e.target.value);
                            }}>
                            {
                                invoiceStates.map(function(is) {
                                    return <option key={is.value} 
                                                value={is.value}
                                                className="optionIS"
                                                >{is.text}</option>
                                })
                            }
                        </Form.Select>
                    </FloatingLabel>
                    <FloatingLabel className="mb-3" controlId="state" label={t('state')}>
                        <Form.Select name="state"
                            value={state}
                            onChange={e => {
                            console.log("e.target.value", e.target.value);
                            setState(e.target.value);
                            }}>
                            {
                                states.map(function(is) {
                                    return <option key={is.value} 
                                                value={is.value}
                                                className="optionState"
                                                >{is.text}</option>
                                })
                            }
                        </Form.Select>
                    </FloatingLabel>
                    <FloatingLabel className="mb-3" controlId="channels" label={t('channels')}>
                        <Form.Control name="channels" placeholder={t('channels')} defaultValue={selected.channels} />
                    </FloatingLabel>
                    <FloatingLabel className="mb-3" controlId="totalExp" label={t('totalExp')}>
                        <Form.Control name="totalExp" placeholder={t('totalExp')} type="number" min="0" required defaultValue={selected.totalExp} />
                    </FloatingLabel>
                    <FloatingLabel className="mb-3" controlId="totalNe" label={t('totalNe')}>
                        <Form.Control name="totalNe" placeholder={t('totalNe')} type="number" min="0" required defaultValue={selected.totalNe} />
                    </FloatingLabel>
                    {/* <Form.Label htmlFor="outputExp">{t('outputExp')}</Form.Label>
                    <Form.Group className="mb-3" controlId="outputExp">
                        <Form.Control type="file" name="outputExp" />
                    </Form.Group>
                    <Form.Label htmlFor="outputNe">{t('outputNe')}</Form.Label>
                    <Form.Group className="mb-3" controlId="outputNe">
                        <Form.Control type="file" name="outputNe" />
                    </Form.Group>
                    <Form.Label htmlFor="report">{t('report')}</Form.Label>
                    <Form.Group className="mb-3" controlId="report">
                        <Form.Control type="file" name="report" />
                    </Form.Group> */}
                </Col>
            </Row>
            <Button type="submit">Submit</Button>
        </Form>
    );
};